import { Injectable } from '@angular/core';
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { EOrder, IConfigurableTable, IConfigurableTableHmpr } from "libraries/interfaces/i-configurable-table";
import { Observable } from "rxjs";

const DEFAULT: IConfigurableTable = {
    "isVisibleHeader": true,
    "defaultSortArray": [
        {"fieldKey": "SYSTEM", "order": EOrder.ascending},
        {"fieldKey": "TRAVELLER", "order": EOrder.descending}
    ],
    "columnArray": [
        {
            "key": "COL_1",
            "defaultLabel": "Auteur",
            "fieldKeyArray": [
                "AUTHOR"
            ],
            "isDisplayed": true
        },
        {
            "key": "COL_2",
            "defaultLabel": "Date de départ",
            "fieldKeyArray": [
                "BEGIN"
            ],
            "isDisplayed": true
        }
    ]
};

@Injectable()
export class TicketingTableDomainService {

    constructor(
        private readonly configurationResourceService: ConfigurationResourceService,
    ) {
    }

    public getTableConfiguration(): Observable<IConfigurableTableHmpr> {
        return this.configurationResourceService.get(
            ['wui', 'app_sasha', 'config', 'hmpr', 'hmpr-table.json'],
            DEFAULT
        ) as Observable<IConfigurableTableHmpr>;
    }
}
